import React, { Component } from 'react';
import { $ } from 'rype-bootstrap';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { browserHistory, withRouter } from 'react-router';

import NavLink from '../NavLink/NavLink';
import { logout } from '../../../actions/userActions';

import './style.css';

class AdminNavBar extends Component {
  constructor(props) {
    super(props);

    $.noConflict();
  }

  handleDisputes = (event) => {
    event.preventDefault();
    event.stopPropagation();
    browserHistory.replace('/admin/disputes');
  }

  handleSearchIssues = (event) => {
    event.preventDefault();
    event.stopPropagation();
    browserHistory.replace('/admin/search-issues');
  }

  handleTeachers = (event) => {
    event.preventDefault();
    event.stopPropagation();
    browserHistory.replace('/admin/teachers');
  }

  handleOnboard = (event) => {
    event.preventDefault();
    event.stopPropagation();
    browserHistory.replace('/admin/onboard');
  }

  handleAccounts = (event) => {
    event.preventDefault();
    event.stopPropagation();
    browserHistory.replace('/admin/accounts');
  }

  handleAppointments = (event) => {
    event.preventDefault();
    event.stopPropagation();
    browserHistory.replace('/admin/appointments-csv');
  }

  handleBadRatings = (event) => {
    event.preventDefault();
    event.stopPropagation();
    browserHistory.replace('/admin/bad-ratings');
  }

  handleLogout = () => {
    // destroy the session data and log out
    this.props.logout();
    browserHistory.replace('/');
  }

  render() {
    return (
      <div className="AdminNavBar px-md-3 px-lg-4">
        <nav className="nav nav-pills flex-column">
          <NavLink to="/admin/disputes" onClick={this.handleDisputes}>
            Disputes
          </NavLink>

          <NavLink to="/admin/search-issues" onClick={this.handleSearchIssues}>
            All Issues
          </NavLink>

          <NavLink to="/admin/teachers" onClick={this.handleTeachers}>
            Teachers
          </NavLink>

          <NavLink to="/admin/onboard" onClick={this.handleOnboard}>
            Onboard
          </NavLink>

          <NavLink to="/admin/accounts" onClick={this.handleAccounts}>
            Accounts
          </NavLink>

          <NavLink to="/admin/appointments-csv" onClick={this.handleAppointments}>
            Appointments
          </NavLink>

          <NavLink to="/admin/bad-ratings" onClick={this.handleBadRatings}>
            Bad Ratings
          </NavLink>
        </nav>
      </div>
    );
  }
}

export default compose(
  withRouter,
  connect(
    null,
    { logout }
  )
)(AdminNavBar);



// WEBPACK FOOTER //
// ./src/components/navigation/AdminNavBar/index.js